import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';

export const PremiumBadge = () => {
    return (
        // wrap the image in a div to make it easier to style
        <span className="badge rounded-pill text-bg-primary m-1">
            <DiamondOutlinedIcon />
        </span>
    )
}